import script from "./DefaultTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultTemplate.vue?vue&type=script&setup=true&lang=js"

import "./DefaultTemplate.vue?vue&type=style&index=0&id=32e4ac03&lang=css"

const __exports__ = script;

export default __exports__